export default __webpack_public_path__ + "static/media/1.4aad7bd0.jpg";